import { render, staticRenderFns } from "./GameListItem.vue?vue&type=template&id=77264e2a&scoped=true"
import script from "./GameListItem.vue?vue&type=script&lang=ts"
export * from "./GameListItem.vue?vue&type=script&lang=ts"
import style0 from "./GameListItem.vue?vue&type=style&index=0&id=77264e2a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77264e2a",
  null
  
)

export default component.exports